import { ref } from 'vue';

const isMobile = ref(true);
const isTablet = ref(false);
const isDesktop = ref(false);
const isWidescreen = ref(false);
const isTabletOrMobile = ref(false);
const isDesktopOrWidescreen = ref(false);

const tablet = 769;
const desktop = 1024;
const widescreen = 1256;

const checkBreakpoint = (event) => {
  const agentWidth = event?.currentTarget?.innerWidth || window.innerWidth;

  isMobile.value = agentWidth < tablet;
  isTablet.value = tablet <= agentWidth && agentWidth < desktop;
  isDesktop.value = desktop <= agentWidth && agentWidth < widescreen;
  isWidescreen.value = widescreen <= agentWidth;
  isTabletOrMobile.value = isTablet.value || isMobile.value;
  isDesktopOrWidescreen.value = isDesktop.value || isWidescreen.value;
};

window.addEventListener('resize', checkBreakpoint);

checkBreakpoint();

export { isMobile, isTablet, isDesktop, isWidescreen, isTabletOrMobile, isDesktopOrWidescreen };
